export enum VulnerabilityType {
    CVE = 'cve'
}